import { LazyLoadedStates, LazyLoadedStatesManager } from '@edl-development/edl-common';

export const UsersAgreementLazyLoadedStates = new LazyLoadedStatesManager<{
    base: LazyLoadedStates
}> ({
    base: {
        name: 'public.user-agreement',
        url: '/user-agreement',
    }
},
() => import('src/app/user-agreement/user-agreement.module').then(mod => mod.UserAgreementModule)
);
